export default {
	/* --- App Version - Sent with Each API Call for Reference --- */
	app_version: process.env.REACT_APP_SITE_VERSION,
	/* --- Endpoints --- */
	portal_url: process.env.REACT_APP_URL_PORTAL,
	api_url: process.env.REACT_APP_URL_API,
	stripe_publisher_key: process.env.REACT_APP_STRIPE_PUBLISHER_KEY
};
